<p-dialog
  header="Editar Registro"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '65%', height: '80vh' }"
>
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoading" class="row">
    <div class="column">
      <!-- Carga de Imagen -->
      <div class="field">
        <label for="fotoPerfil" class="font-semibold">Foto de perfil</label>
        <div class="profile-photo-container">
          <div class="photo-preview" (click)="openFileUpload('image')">
            <img
              *ngIf="selectedPhoto"
              [src]="selectedPhoto"
              alt="Foto de perfil"
              class="profile-photo"
            />
            <i *ngIf="!selectedPhoto" class="pi pi-user"></i>
          </div>
          <div class="photo-actions">
            <div class="photo-actions-start">
              <div (click)="editPhoto()" class="photo-action">
                <i class="pi pi-pencil"></i> Editar
              </div>
              <div (click)="addPhoto()" class="photo-action">
                <i class="pi pi-camera"></i> Añadir foto
              </div>
            </div>
            <div (click)="removePhoto()" class="photo-action">
              <i class="pi pi-trash"></i> Eliminar
            </div>
          </div>
        </div>
        <p-fileUpload
          #imageUploader
          [accept]="'image/*'"
          [maxFileSize]="10000000"
          (onSelect)="onPhotoSelect($event)"
          [style]="{ display: 'none' }"
        ></p-fileUpload>
      </div>

      <!-- Contenedor de Empresa y Puesto -->
      <div class="field-container">
        <!-- Empresa -->
        <div class="field">
          <label for="company" class="font-semibold">Empresa</label>
          <p-autoComplete
            id="company"
            [(ngModel)]="selectedCompany"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'company')"
            (input)="onChangeInput($event, 'company')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona una empresa'"
            (onSelect)="onSelect($event, 'company')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>

        <!-- Puesto -->
        <div class="field">
          <label for="jobPosition" class="font-semibold">Puesto</label>
          <p-autoComplete
            id="jobPosition"
            [(ngModel)]="selectedJobPosition"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'jobPosition')"
            (input)="onChangeInput($event, 'jobPosition')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona un puesto'"
            (onSelect)="onSelect($event, 'jobPosition')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>
      </div>

      <!-- Contenedor de Modalidad y Fecha de Ingreso -->
      <div class="field-container">
        <!-- Modalidad -->
        <div class="field">
          <label for="workingMode" class="font-semibold">Modalidad</label>
          <p-autoComplete
            id="workingMode"
            [(ngModel)]="selectedWorkingMode"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'workingMode')"
            (input)="onChangeInput($event, 'workingMode')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona una modalidad'"
            (onSelect)="onSelect($event, 'workingMode')"
            [style]="{ width: '100%' }"
            [disabled]="true"
            [field]="'text'"
          ></p-autoComplete>
        </div>

        <!-- Fecha de Ingreso -->
        <div class="calendar-item">
          <label for="startDate">Fecha de Ingreso</label>
          <p-calendar
            id="startDate"
            [(ngModel)]="startDate"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="DD/MM/YYYY"
            (onSelect)="validateFormEmployee()"
            (onBlur)="validateField('startDate')"
            [styleClass]="'custom-birthdate-calendar'"
          ></p-calendar>
        </div>
      </div>

      <!-- Contenedor de País y Ciudad -->
      <div class="field-container">
        <!-- País -->
        <div class="field">
          <label for="country" class="font-semibold">País</label>
          <p-autoComplete
            id="country"
            [(ngModel)]="selectedCountry"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'country')"
            (input)="onChangeInput($event, 'country')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona un país'"
            (onSelect)="onSelect($event, 'country')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>

        <!-- Ciudad -->
        <div class="field">
          <label for="city" class="font-semibold">Ciudad</label>
          <p-autoComplete
            id="city"
            [(ngModel)]="selectedCity"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'city')"
            (input)="onChangeInput($event, 'city')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona una ciudad'"
            (onSelect)="onSelect($event, 'city')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>
      </div>
    </div>

    <div class="column">
      <!-- Nombres -->
      <div class="field">
        <label for="name" class="font-semibold">Nombres</label>
        <input
          pInputText
          id="name"
          type="text"
          [(ngModel)]="name"
          (ngModelChange)="onChangeInput($event, 'name')"
          [placeholder]="'Ingresa nombres completos'"
        />
      </div>

      <!-- Apellidos -->
      <div class="field">
        <label for="lastname" class="font-semibold">Apellidos</label>
        <input
          pInputText
          id="lastname"
          type="text"
          [(ngModel)]="lastname"
          (ngModelChange)="onChangeInput($event, 'lastname')"
          [placeholder]="'Ingresa apellidos completos'"
        />
      </div>

      <div class="field-container">
        <!-- Tipo de Documento -->
        <div class="field">
          <label for="typeDocument" class="font-semibold"
            >Tipo de Documento</label
          >
          <p-autoComplete
            id="typeDocument"
            [(ngModel)]="selectedTypeDocument"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'typeDocument')"
            (input)="onChangeInput($event, 'typeDocument')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona un tipo'"
            (onSelect)="onSelect($event, 'typeDocument')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>

        <!-- Documento -->
        <div class="field">
          <label for="document" class="font-semibold"
            >Número de Documento</label
          >
          <input
            id="document"
            type="text"
            pInputText
            [(ngModel)]="document"
            (ngModelChange)="onChangeInput($event, 'document')"
            (keypress)="onlyNumbers($event)"
            [maxlength]="maxLength"
            placeholder="Ingresa número de documento"
          />
        </div>
      </div>

      <div class="field-container">
        <!-- Fecha de Cumpleaños -->
        <div class="calendar-item">
          <label for="birthDate">Fecha de Nacimiento</label>
          <p-calendar
            id="birthDate"
            [(ngModel)]="birthDate"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="DD/MM/YYYY"
            (onSelect)="validateFormEmployee()"
            (onBlur)="validateField('birthDate')"
            [styleClass]="'custom-birthdate-calendar'"
          ></p-calendar>
        </div>

        <!-- Género -->
        <div class="field">
          <label for="gender" class="font-semibold">Género</label>
          <p-autoComplete
            id="gender"
            [(ngModel)]="selectedGender"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'gender')"
            (input)="onChangeInput($event, 'gender')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona'"
            (onSelect)="onSelect($event, 'gender')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>
      </div>

      <div class="field-container">
        <!-- Celular -->
        <div class="field">
          <label for="phone" class="font-semibold">Celular</label>
          <p-inputGroup>
            <p-inputGroupAddon>
              <span *ngIf="selectedPhoneCode" class="phone-prefix"
                >+{{ selectedPhoneCode }}</span
              >
            </p-inputGroupAddon>
            <p-inputNumber
              id="phone"
              mode="decimal"
              inputId="withoutgrouping"
              [useGrouping]="false"
              [(ngModel)]="phone"
              (ngModelChange)="onChangeInput($event, 'phone')"
              [placeholder]="'Ingresa celular'"
            ></p-inputNumber>
          </p-inputGroup>
        </div>

        <!-- Correo -->
        <div class="field">
          <label for="email" class="font-semibold">Correo</label>
          <input
            pInputText
            id="email"
            type="email"
            [(ngModel)]="email"
            (ngModelChange)="onChangeInput($event, 'email')"
            [placeholder]="'Ingresa correo'"
          />
        </div>
      </div>

      <!-- Dirección -->
      <div class="field">
        <label for="address" class="font-semibold">Dirección</label>
        <input
          pInputText
          id="address"
          type="text"
          [(ngModel)]="address"
          (ngModelChange)="onChangeInput($event, 'address')"
          [placeholder]="'Ingresa dirección actual'"
        />
      </div>

      <div class="motivo-floating-card" *ngIf="selectedStatusEmployee?.key == EMPLOYEE_STATUS.INACTIVE">
        <div class="motivo-header" (click)="showMotivo = !showMotivo">
          <label class="label2">Seleccione motivo</label>
          <span class="toggle-icon">{{ showMotivo ? '▾' : '▸' }}</span>
        </div>
        <div *ngIf="showMotivo">
          <div class="calendar-item" style="margin-bottom: 1rem; max-width: 145px;">
            <label for="terminationDate">Fecha de CESE</label>
            <p-calendar
              id="terminationDate"
              [(ngModel)]="terminationDate"
              [showIcon]="true"
              dateFormat="dd/mm/yy"
              placeholder="DD/MM/YYYY"
              (onSelect)="validateFormEmployee()"
              (onBlur)="validateField('terminationDate')"
              [styleClass]="'custom-birthdate-calendar'"
          ></p-calendar>
          </div>
          <div class="motivo-options">
            <label><input type="radio" name="motivo" [(ngModel)]="selectedMotivo" value="Por despido" /> Por despido</label>
            <label><input type="radio" name="motivo" [(ngModel)]="selectedMotivo" value="Mutuo disenso" /> Mutuo disenso</label>
            <label><input type="radio" name="motivo" [(ngModel)]="selectedMotivo" value="Renuncia" /> Renuncia</label>
            <label><input type="radio" name="motivo" [(ngModel)]="selectedMotivo" value="Finalización de Contrato" /> Finalización de
              Contrato</label>
            <label><input type="radio" name="motivo" [(ngModel)]="selectedMotivo" value="Otro" /> Otro</label>
          </div>
          <textarea
          *ngIf="selectedMotivo === 'Otro'" 
          [(ngModel)]="motivoOtro"
          maxlength="250" class="motivo-textarea" 
          placeholder="Describe el motivo."></textarea>
        </div>
      </div>

      <div class="field-container">
        <!-- Celular Emergencia -->
        <div class="field">
          <label for="phone" class="font-semibold"
            >Contacto de emergencia</label
          >
          <p-inputGroup>
            <p-inputGroupAddon>
              <span *ngIf="selectedPhoneCode" class="phone-prefix"
                >+{{ selectedPhoneCode }}</span
              >
            </p-inputGroupAddon>
            <p-inputNumber
              id="phoneEmergency"
              mode="decimal"
              inputId="withoutgrouping"
              [useGrouping]="false"
              [(ngModel)]="phoneEmergency"
              (ngModelChange)="onChangeInput($event, 'phoneEmergency')"
              [placeholder]="'Ingresa celular'"
            ></p-inputNumber>
          </p-inputGroup>
        </div>

        <!-- Status Empleado -->
        <div class="field">
          <label for="email" class="font-semibold">Status del Empleado</label>
          <p-autoComplete
            id="statusEmployee"
            [(ngModel)]="selectedStatusEmployee"
            [suggestions]="filteredOptions"
            (completeMethod)="filterOptions($event, 'statusEmployee')"
            (input)="onChangeInput($event, 'statusEmployee')"
            [dropdown]="true"
            [forceSelection]="true"
            [placeholder]="'Selecciona un estado'"
            (onSelect)="onSelect($event, 'statusEmployee')"
            [style]="{ width: '100%', backgroundColor: 'white' }"
            [field]="'text'"
          ></p-autoComplete>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isLoading"
    style="display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: auto; padding: 16px 24px; box-shadow: 0 -1px 0 1px rgba(0, 0, 0, 0.08);"
  >
    <div style="display: inline-flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-left: auto;">
      <button
        type="button"
        pButton
        label="Ahora no"
        class="btn btn-default"
        (click)="closeDialog()"
      ></button>

      <button
        type="button"
        pButton
        label="Siguiente"
        class="btn btn-solid"
        [disabled]="isDisabledEmployee"
        (click)="goToContractStep()"
      ></button>
    </div>
  </div>
</p-dialog>
